import React from 'react';

// tslint:disable-next-line:import-name
import style from './index.module.css';

export interface ListGroupItemProps {
  selected?: boolean;
  children: JSX.Element | JSX.Element[];
}

// tslint:disable-next-line:function-name
export function ListGroupItem({ children, selected }: ListGroupItemProps) {
  return <div className={`${style.ListGroupItem} ${selected ? style.ListGroupItemSelected : ''}`}>
    {children}
  </div>;
}

export interface ListGroupProps {
  children: JSX.Element | JSX.Element[];
  className?: string;
}

export default function ({ children, className }: ListGroupProps) {
  return <div className={`${style.ListGroup} ${className}`}>
    {children}
  </div>;
}
